var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customizer-header"},[_c('i',{staticClass:"icofont-close icon-close",on:{"click":function($event){return _vm.closecustomizer()}}}),_c('h5',[_vm._v("Customizer")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0"},[_vm._v(" Try It Real Time "),_c('i',{staticClass:"fa fa-thumbs-o-up txt-primary"})])
}]

export { render, staticRenderFns }